// src/components/discovery/CandidateRow.jsx
// Flat table row for the candidates table.

import React from 'react';
import { TableRow, TableCell, Typography, Chip } from '@mui/material';
import ConfidenceDots from './ConfidenceDots';
import DedupChip from './DedupChip';
import { FS } from '../../theme/tokens';
import { formatMoney } from '../../utils/format';
import { sourceTierLabel } from '../../utils/labels';

const SOURCE_COLORS = {
  idealo:   'primary',
  geizhals: 'secondary',
  serpapi:  'default',
};

const STATUS_COLORS = {
  pending:  'warning',
  approved: 'success',
  rejected: 'error',
  deferred: 'default',
};

export default function CandidateRow({ candidate, onSelect, selected }) {
  const price = candidate.raw_price != null
    ? formatMoney(Number(candidate.raw_price))
    : '—';

  return (
    <TableRow
      hover
      selected={selected}
      onClick={() => onSelect(candidate)}
      sx={{ cursor: 'pointer' }}
    >
      {/* Shop */}
      <TableCell sx={{ py: 1 }}>
        <Typography noWrap sx={{ fontSize: FS.base, fontWeight: 500, lineHeight: 1.3 }}>
          {candidate.shop_host}
        </Typography>
        {candidate.shop_name && (
          <Typography noWrap sx={{ fontSize: FS.sm, color: 'text.secondary', lineHeight: 1.3 }}>
            {candidate.shop_name}
          </Typography>
        )}
      </TableCell>

      {/* SKU */}
      <TableCell sx={{ py: 1 }}>
        <Typography noWrap sx={{ fontSize: FS.sm, fontFamily: 'monospace', color: 'text.secondary' }}>
          {candidate.matched_sku || '—'}
        </Typography>
      </TableCell>

      {/* Confidence */}
      <TableCell sx={{ py: 1 }}>
        <ConfidenceDots
          confidence={candidate.match_confidence}
          method={candidate.match_method}
        />
      </TableCell>

      {/* Dedup */}
      <TableCell sx={{ py: 1 }}>
        <DedupChip dedupStatus={candidate.dedup_status} />
      </TableCell>

      {/* Price */}
      <TableCell align="right" sx={{ py: 1 }}>
        <Typography sx={{ fontSize: FS.sm, fontVariantNumeric: 'tabular-nums' }}>
          {price}
        </Typography>
      </TableCell>

      {/* Source */}
      <TableCell sx={{ py: 1 }}>
        <Chip
          label={sourceTierLabel(candidate.source_tier, '—')}
          color={SOURCE_COLORS[candidate.source_tier] || 'default'}
          size="small"
          sx={{ fontSize: FS.xs, height: 20 }}
        />
      </TableCell>

      {/* Status */}
      <TableCell sx={{ py: 1 }}>
        <Chip
          label={candidate.status || '—'}
          color={STATUS_COLORS[candidate.status] || 'default'}
          size="small"
          sx={{ fontSize: FS.xs, height: 20, fontWeight: 500 }}
        />
      </TableCell>
    </TableRow>
  );
}
